import { render, staticRenderFns } from "./TextBanner.vue?vue&type=template&id=6a475065&"
import script from "./TextBanner.vue?vue&type=script&lang=js&"
export * from "./TextBanner.vue?vue&type=script&lang=js&"
import style0 from "./TextBanner.vue?vue&type=style&index=0&id=6a475065&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports